module.exports = __webpack_public_path__ + "img/about-m-slide-6.6b2e4740.jpg";